export default "__VITE_PUBLIC_ASSET__ac1ef2ea__"